import React from 'react';
import TagModal from './tagModal';
import DeleteModal from './deleteModal';
import DuplicateModal from './duplicateModal';

export default function ActionModals({ organization, resetPagination, event, events, open, onClose, tags }) {
    if (!event || !open) {
        return null;
    }

    return (
        <>
            <DeleteModal onClose={onClose} event={event} organization={organization} resetPagination={resetPagination} open={Boolean(event && open === 'delete')} />
            <TagModal tags={tags} onClose={onClose} organization={organization} event={event} open={Boolean(event && open === 'tag')} />
            <DuplicateModal
                event={event}
                allEvents={events}
                organization={organization}
                resetPagination={resetPagination}
                onClose={onClose}
                open={Boolean(event && open === 'duplicate')}
            />
        </>
    );
}
